// TODO: handleUserDataUpdate a write unit test
export default function handleUserDataUpdate(state, action) {
  const newState = {
    ...state,
    userData: { ...state.userData, ...action.update },
  };

  return newState;
}
